import type { MembershipDetails } from '../../entities/entityTypes';
import { captureWarning } from '../../logger/Logger';
import { useSendbird } from './useSendbird';

export const useSendMessage = (membership?: MembershipDetails) => {
    const { sdk: sendbirdSdk } = useSendbird();

    const sendMessage = async (message: string) => {
        if (membership == null) {
            captureWarning('Missing membership to send message');
            return;
        }

        if (sendbirdSdk == null) {
            captureWarning('SendbirdSdk not initialized');
            return;
        }

        const channelUrl = membership.messagingChannel?.channelUrl;
        if (channelUrl == null) {
            captureWarning('Missing messaging channel to send message');
            return;
        }

        const channel = await sendbirdSdk.groupChannel.getChannel(channelUrl);

        if (channel == null) {
            captureWarning('Cannot find channel to send message');
            return;
        }

        // Strip zero-width spaces from message to prevent broken links when copying/pasting
        const cleanedMessage = message.replace(/[\u200B]/g, '');
        channel.sendUserMessage({
            message: cleanedMessage,
        });
    };

    return { sendMessage };
};
